import { useQuery } from "@tanstack/react-query";
import WarehouseService from "../services/Warehouses/WarehouseService";

const useWarehouseDock = ({ warehouseId, receivingZoneId }) => {
  return useQuery({
    queryKey: [warehouseId, "docks"],
    queryFn: async () => await WarehouseService.getDocksByWarehouseId(warehouseId),
    enabled: !!receivingZoneId,
  });
};

export default useWarehouseDock;